export const AGENT_PROVIDERS = ['openai', 'gemini', 'groq'] as const;

export type AgentProvider = (typeof AGENT_PROVIDERS)[number];
